import { Utilities as utilities } from "@truckdown/framework";

export class CaptchaResponse {
    constructor(json?: any) {
        if (json) {
            this.success = utilities.json.getBooleanValue(json, 'success', false);
            this.errorCodes = utilities.json.getArrayValue(json,
                (itm) => { return itm as string; }, 'error-codes', []);
        }
    }

    toJSON() {
        return {
            success: this.success,
            'error-codes': this.errorCodes
        };
    }

    success: boolean = false;
    errorCodes: string[] = [];
}